import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index.jsx";
import Icons from "../../assets/icons/index.jsx";
import { useMutation, useQuery } from "@apollo/client";
import { GET_Other_Resource } from "../../gql/queries.jsx";
import {
  Link,
  NavLink,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import {
  getPercentage,
  trimText,
  getTime,
  getVideoTime,
  getProgressPercentage,
  getProgressVideoPercentage,
  getVideoProgressPercentage,
} from "../../utils/index.js";
import Modal from "react-bootstrap/Modal";
import { GET_Bookmarked_Video } from "../../gql/mutation.jsx";
import NoDataFound from "../common/NoDataFound/NoDataFound.jsx";
import { authorizationCheck } from "../../utils/logout.jsx";
import Loader from "../common/Loader/Loader.jsx";
import { decrypt, decryptdata } from "../../utils/crypto";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong.jsx";
import ConnectionError from "../common/NoDataFound/ConnectionError.jsx";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
function OtherResource() {
  const location = useLocation();
  let { id } = useParams();
  const [show, setShow] = useState(false);
  const [course, setCourse] = useState(
    JSON.parse(decrypt(localStorage.getItem("profileDetails")))
  );
  const [version, setVersion] = useState(
    JSON.parse(localStorage.getItem("version"))
  );
  const [language, setLanguage] = useState(
    JSON.parse(localStorage.getItem("language"))
  );
  const packageStatus = JSON.parse(
    decrypt(localStorage.getItem("packageStatus"))
  );
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const naviagte = useNavigate();
  // trackEvent("ViewedWebPage", {
  //   url: window.location.href,
  //   timestamp: Date.now(),
  // });
  const [getBookmark] = useMutation(GET_Bookmarked_Video, {
    refetchQueries: [
      {
        query: GET_Other_Resource,
        variables: {
          _id: id,
          language: language,
          contentType: "videos",
        },
      }, // DocumentNode object parsed with gql
      "topicList", // Query name,
    ],
    context: {
      headers: {
        deviceId: "49c979a9-a202-424a-900b-83baa3e6d1c7",
      },
    },
  });
  const query1 = useQuery(GET_Other_Resource, {
    variables: {
      layerId: id,
      language: language,
      contentType: "videos",
    },
  });

  if (query1.loading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  if (query1.error) {
    if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "UNAUTHENTICATED"
      )
    ) {
      authorizationCheck(naviagte);
    } else if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      )
    ) {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <SomethingWentWrong pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <ConnectionError pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    }
    console.log(query1.error.graphQLErrors);
  }
  const checkVersionStatus = query1?.data?.layer?.subContents?.filter((name) =>
    name?.video?.version.includes(parseInt(version?.actual))
  ).length;
  if (checkVersionStatus === 0) {
    return (
      <>
        <div className="main_wrapper">
          <div className="col-lg-12">
            <NoDataFound />
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      {/* // subject layer */}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType === "subject" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "topic" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "resource" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "concept" &&
        naviagte(`/videolayer`, { replace: true })}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "subject" &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "topic" &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "resource" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "concept" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "" && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <div className="subjects_wrapper topic_header">
                    <div className="topic_header_content d-flex align-items-center">
                      <div className="topic_image_ttl d-flex align-items-center">
                        {/* <Link to={`${query1.data && query1.data.layer.parents?`/videolayer/otherResource/${query1.data && query1.data.layer.parents}`:'/videolayer'}`}> */}
                        <figure
                          className="back_arrow"
                          onClick={() => naviagte(-1)}
                        >
                          <img
                            src={Icons.BackArrow}
                            alt="Back Arrow"
                            className="img-fluid"
                          />
                        </figure>
                        {/* </Link> */}
                        <figure className="subject_inner_img">
                          <img
                            src={
                              query1.data.layer
                                ? query1.data.layer.icon
                                : Images.defaultImg
                            }
                            alt="Subject Image"
                            className="img-fluid"
                          />
                        </figure>
                        <div className="subject_ttl_detail">
                          <h5>
                            {query1.data.layer && query1.data.layer.title}{" "}
                          </h5>
                          <p>Other Resources</p>
                        </div>
                      </div>
                      {/* <div className="search_icon">
											<img src={Icons.SearchIcon} alt="" className="img-fluid" />
										</div> */}
                    </div>
                    <div className="progress_bar">
                      <div className="progress_details d-flex align-items-center">
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) !== 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) === 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar completed"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}

                        <div className="completed_text">
                          <span>{`${getPercentage(
                            query1.data ? query1.data.layer : 0
                          )}%`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {query1.data.layer !== undefined && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>
                          All Topics (
                          {query1.data.layer
                            ? query1.data.layer.subLayers.filter((name) =>
                              name?.versions.includes(
                                parseInt(version?.actual)
                              )
                            ).length
                            : 0}
                          )
                        </h6>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {query1.data.layer &&
                            query1.data.layer.subLayers[0].subLayers
                              .filter((name) =>
                                name?.versions.includes(
                                  parseInt(version?.actual)
                                )
                              )
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-itmes-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div className="subject_details">
                                        <Link
                                          to={`/videolayer/otherResource/${d._id}`}
                                        >
                                          <h6>{d.title}</h6>
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          {getPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {getPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* <div className="right_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div> */}
                                  </div>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        )}
      {/* // topic layer */}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType === "topic" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "resource" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "concept" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "subject" && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <div className="subjects_wrapper topic_header">
                    <div className="topic_header_content d-flex align-items-center">
                      <div className="topic_image_ttl d-flex align-items-center">
                        {/* <Link to={`/videolayer/otherResource/${query1.data && query1.data.layer.parents}`}> */}
                        <figure
                          className="back_arrow"
                          onClick={() => naviagte(-1)}
                        >
                          <img
                            src={Icons.BackArrow}
                            alt="Back Arrow"
                            className="img-fluid"
                          />
                        </figure>
                        {/* </Link> */}
                        <figure className="subject_inner_img">
                          <img
                            src={
                              query1.data.layer
                                ? query1.data.layer.icon
                                : Images.defaultImg
                            }
                            alt="Subject Image"
                            className="img-fluid"
                          />
                        </figure>
                        <div className="subject_ttl_detail">
                          <h5>
                            {query1.data.layer && query1.data.layer.title}
                          </h5>
                          <p>Other Resources</p>
                        </div>
                      </div>
                      {/* <div className="search_icon">
											<img src={Icons.SearchIcon} alt="" className="img-fluid" />
										</div> */}
                    </div>
                    <div className="progress_bar">
                      <div className="progress_details d-flex align-items-center">
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) !== 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) === 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar completed"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}

                        <div className="completed_text">
                          <span>{`${getPercentage(
                            query1.data ? query1.data.layer : 0
                          )}%`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {query1.data.layer !== undefined && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>
                          All Resources (
                          {query1.data.layer
                            ? query1.data.layer.subLayers.filter((name) =>
                              name?.versions.includes(
                                parseInt(version?.actual)
                              )
                            ).length
                            : 0}
                          )
                        </h6>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {query1.data.layer &&
                            query1?.data?.layer?.subLayers
                              ?.filter((name) =>
                                name?.versions?.includes(
                                  parseInt(version?.actual)
                                )
                              )
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-itmes-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div className="subject_details">
                                        <Link
                                          to={`/videolayer/otherResource/${d._id}`}
                                        >
                                          <h6>{d.title}</h6>
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          {getPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {getPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* <div className="right_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div> */}
                                  </div>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        )}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType === "resource" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "topic" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "concept" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "subject" && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <div className="subjects_wrapper topic_header">
                    <div className="topic_header_content d-flex align-items-center">
                      <div className="topic_image_ttl d-flex align-items-center">
                        {/* <Link to={`/videolayer/otherResource/${query1.data && query1.data.layer.parents}`}> */}
                        <figure
                          className="back_arrow"
                          onClick={() => naviagte(-1)}
                        >
                          <img
                            src={Icons.BackArrow}
                            alt="Back Arrow"
                            className="img-fluid"
                          />
                        </figure>
                        {/* </Link> */}
                        <figure className="subject_inner_img">
                          <img
                            src={
                              query1.data.layer
                                ? query1.data.layer.icon
                                : Images.defaultImg
                            }
                            alt="Subject Image"
                            className="img-fluid"
                          />
                        </figure>
                        <div className="subject_ttl_detail">
                          <h5>
                            {query1.data.layer && query1.data.layer.title}
                          </h5>
                          <p>Other Resources</p>
                        </div>
                      </div>
                      {/* <div className="search_icon">
										<img src={Icons.SearchIcon} alt="" className="img-fluid" />
									</div> */}
                    </div>
                    <div className="progress_bar">
                      <div className="progress_details d-flex align-items-center">
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) !== 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) === 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar completed"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}

                        <div className="completed_text">
                          <span>{`${getPercentage(
                            query1.data ? query1.data.layer : 0
                          )}%`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {query1.data.layer !== undefined && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>
                          All Resources (
                          {query1.data.layer
                            ? query1.data.layer.subLayers.filter((name) =>
                              name?.versions.includes(
                                parseInt(version?.actual)
                              )
                            ).length
                            : 0}
                          )
                        </h6>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {query1.data.layer &&
                            query1?.data?.layer?.subLayers
                              ?.filter((name) =>
                                name?.versions?.includes(
                                  parseInt(version?.actual)
                                )
                              )
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-itmes-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div className="subject_details">
                                        <Link
                                          to={`/videolayer/otherResource/${d._id}`}
                                        >
                                          <h6>{d.title}</h6>
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          {getPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {getPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* <div className="right_arrow">
															<img src={Icons.VideoArrow} alt="" className="img-fluid" />
														</div> */}
                                  </div>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        )}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType === "concept" && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <div className="subjects_wrapper topic_header">
                    <div className="topic_header_content d-flex align-items-center">
                      <div className="topic_image_ttl d-flex align-items-center">
                        {/* <Link to={`/videolayer/otherResource/${query1.data && query1.data.layer.parents}`}> */}
                        <figure
                          className="back_arrow"
                          onClick={() => naviagte(-1)}
                        >
                          <img
                            src={Icons.BackArrow}
                            alt="Back Arrow"
                            className="img-fluid"
                          />
                        </figure>
                        {/* </Link> */}
                        <figure className="subject_inner_img">
                          <img
                            src={
                              query1.data.layer
                                ? query1.data.layer.icon
                                : Images.defaultImg
                            }
                            alt="Subject Image"
                            className="img-fluid"
                          />
                        </figure>
                        <div className="subject_ttl_detail">
                          <h5>
                            {query1.data.layer && query1.data.layer.title}
                          </h5>
                          <p>Other Resources</p>
                        </div>
                      </div>
                      {/* <div className="search_icon">
											<img src={Icons.SearchIcon} alt="" className="img-fluid" />
										</div> */}
                    </div>
                    <div className="progress_bar">
                      <div className="progress_details d-flex align-items-center">
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) !== 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) === 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar completed"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}

                        <div className="completed_text">
                          <span>{`${getPercentage(
                            query1.data ? query1.data.layer : 0
                          )}%`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {query1.data.layer !== undefined && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>
                          All Resources (
                          {query1.data.layer
                            ? query1.data.layer.subLayers.filter((name) =>
                              name?.versions.includes(
                                parseInt(version?.actual)
                              )
                            ).length
                            : 0}
                          )
                        </h6>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {query1.data.layer &&
                            query1.data.layer.subLayers
                              .filter((name) =>
                                name?.versions.includes(
                                  parseInt(version?.actual)
                                )
                              )
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-itmes-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div className="subject_details">
                                        <Link
                                          to={`/videolayer/otherResource/${d._id}`}
                                        >
                                          <h6>{d.title}</h6>
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          {getPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {getPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* <div className="right_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div> */}
                                  </div>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        )}
      {query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        (query1.data.layer.subLayers[0].layerType === null ||
          query1.data.layer.subLayers[0].layerType === "") &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "resource" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "concept" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "subject" &&
        query1.data &&
        query1.data.layer.subLayers !== null &&
        query1.data.layer.subContents === null &&
        query1.data.layer.subLayers[0] &&
        query1.data.layer.subLayers[0].layerType !== "topic" && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <div className="subjects_wrapper topic_header">
                    <div className="topic_header_content d-flex align-items-center">
                      <div className="topic_image_ttl d-flex align-items-center">
                        <Link
                          to={`${query1.data && query1.data.layer.parents == null
                              ? "/videolayer"
                              : `/videolayer/otherResource/${query1.data.layer.parents}`
                            }`}
                        >
                          <figure className="back_arrow">
                            <img
                              src={Icons.BackArrow}
                              alt="Back Arrow"
                              className="img-fluid"
                            />
                          </figure>
                        </Link>
                        <figure className="subject_inner_img">
                          <img
                            src={
                              query1.data.layer
                                ? query1.data.layer.icon
                                : Images.defaultImg
                            }
                            alt="Subject Image"
                            className="img-fluid"
                          />
                        </figure>
                        <div className="subject_ttl_detail">
                          <h5>
                            {query1.data.layer && query1.data.layer.title}
                          </h5>
                          <p>Other Resources</p>
                        </div>
                      </div>
                      {/* <div className="search_icon">
											<img src={Icons.SearchIcon} alt="" className="img-fluid" />
										</div> */}
                    </div>
                    <div className="progress_bar">
                      <div className="progress_details d-flex align-items-center">
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) !== 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}
                        {getPercentage(
                          query1.data.layer ? query1.data.layer : 0
                        ) === 100 && (
                            <div className="progress">
                              <div
                                className="progress-bar completed"
                                style={{
                                  width: `${getPercentage(
                                    query1.data.layer ? query1.data.layer : 0
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          )}

                        <div className="completed_text">
                          <span>{`${getPercentage(
                            query1.data ? query1.data.layer : 0
                          )}%`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {query1.data.layer !== undefined && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>
                          All Resources (
                          {query1.data.layer
                            ? query1.data.layer.subLayers.filter((name) =>
                              name?.versions.includes(
                                parseInt(version?.actual)
                              )
                            ).length
                            : 0}
                          )
                        </h6>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {query1.data.layer &&
                            query1.data.layer.subLayers
                              .filter((name) =>
                                name?.versions.includes(
                                  parseInt(version?.actual)
                                )
                              )
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-itmes-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div className="subject_details">
                                        <Link
                                          to={`/videolayer/otherResource/${d._id}`}
                                        >
                                          <h6>{d.title}</h6>
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          {getPercentage(d) !== 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {getPercentage(d) === 100 && (
                                            <div className="progress">
                                              <div
                                                className="progress-bar completed"
                                                style={{
                                                  width: `${getPercentage(d)}%`,
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* <div className="right_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div> */}
                                  </div>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        )}

      {query1.data &&
        query1.data.layer.subLayers &&
        query1.data.layer.subLayers.length < 1 &&
        query1.data.layer.subContents &&
        query1.data.layer.subContents.length > 0 && (
          <div className="main_wrapper">
            <div className="breadcrumbs">
              <ul className="breadcrumb"></ul>
            </div>
            <section className="videoLayer_wrapper section_side_padding">
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-12">
                  <div className="topics_wrapper_main">
                    <div className="subjects_wrapper topic_header">
                      <div className="topic_header_content d-flex align-items-center">
                        <div className="topic_image_ttl d-flex align-items-center">
                          {/* <Link to={`/videolayer/otherResource/${query1.data && query1.data.layer.parents}`}> */}
                          <figure
                            className="back_arrow"
                            onClick={() => naviagte(-1)}
                          >
                            <img
                              src={Icons.BackArrow}
                              alt="Back Arrow"
                              className="img-fluid"
                            />
                          </figure>
                          {/* </Link> */}
                          <figure className="subject_inner_img">
                            <img
                              src={
                                query1.data?.layer?.icon
                                  ? query1.data?.layer?.icon
                                  : Images.defaultVideo
                              }
                              alt="Subject Image"
                              className="img-fluid"
                            />
                          </figure>
                          <div className="subject_ttl_detail">
                            <h5>
                              {query1.data.layer && query1.data.layer.title}
                            </h5>
                            <p>Other Resources</p>
                          </div>
                        </div>
                        {/* <div className="search_icon">
												<img src={Icons.SearchIcon} alt="" className="img-fluid" />
											</div> */}
                      </div>
                      <div className="progress_bar">
                        <div className="progress_details d-flex align-items-center">
                          {getPercentage(
                            query1.data.layer ? query1.data.layer : 0
                          ) !== 100 && (
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  style={{
                                    width: `${getPercentage(
                                      query1.data.layer ? query1.data.layer : 0
                                    )}%`,
                                  }}
                                ></div>
                              </div>
                            )}
                          {getPercentage(
                            query1.data.layer ? query1.data.layer : 0
                          ) === 100 && (
                              <div className="progress">
                                <div
                                  className="progress-bar completed"
                                  style={{
                                    width: `${getPercentage(
                                      query1.data.layer ? query1.data.layer : 0
                                    )}%`,
                                  }}
                                ></div>
                              </div>
                            )}

                          <div className="completed_text">
                            <span>{`${getPercentage(
                              query1.data ? query1.data.layer : 0
                            )}%`}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="recommended_video_wrapper videoMainContent">
                      <div className="main_tabs_wrapper">
                        <div className="tab-content">
                          <div className="subjects_header">
                            <h6>
                              All Videos (
                              {query1.data.layer
                                ? query1.data.layer.subContents.filter((name) =>
                                  name?.video.version.includes(
                                    parseInt(version?.actual)
                                  )
                                ).length
                                : 0}
                              )
                            </h6>
                          </div>
                          <div className="tab-pane active" id="videos">
                            <div className="recommend_video_details">
                              <ul type="none" className="recommend_list">
                                {
                                  // filter(name => name.video?.version?.includes((version?.actual)))
                                  query1.data && query1.data.layer.subContents
                                    ? query1.data.layer.subContents
                                      .filter((name) =>
                                        name?.video?.version.includes(
                                          parseInt(version?.actual)
                                        )
                                      )
                                      .slice()
                                      .sort((a, b) =>
                                        a.position > b.position ? -1 : 1
                                      )
                                      .map((d, i) => (
                                        <li>
                                          <div className="recommend_list_main d-flex align-items-center">
                                            <figure
                                              className="user_img"
                                              onClick={handleShow}
                                            >
                                              <img
                                                src={
                                                  d.video.thumbnail
                                                    ? d?.video?.thumbnail
                                                    : Images.defaultImg
                                                }
                                                alt=""
                                                className="img-fluid"
                                              />
                                              {d.video &&
                                                d.video.purchaseStatus !==
                                                0 && (
                                                  <figcaption className="free_tag">
                                                    <span>
                                                      <img
                                                        src={Icons.Lock}
                                                        alt="Lock"
                                                        className="img-fluid"
                                                      />{" "}
                                                      Pro
                                                    </span>
                                                  </figcaption>
                                                )}
                                              {d.video &&
                                                d.video.purchaseStatus ===
                                                0 &&
                                                packageStatus?.isTrialUser ===
                                                false &&
                                                packageStatus?.activePackageLength ===
                                                0 && (
                                                  <figcaption className="free_tag">
                                                    <span>Free</span>
                                                  </figcaption>
                                                )}
                                              <figcaption
                                                className="progress_details"
                                                onClick={handleShow}
                                              >
                                                {parseInt(version.actual) <
                                                  4 &&
                                                  getVideoProgressPercentage(
                                                    d.video
                                                  ) < 100 && (
                                                    <div className="progress">
                                                      <div
                                                        className="progress-bar"
                                                        style={{
                                                          width: `${getVideoProgressPercentage(
                                                            d.video
                                                          )}%`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                                {parseInt(version.actual) >
                                                  4 &&
                                                  getProgressVideoPercentage(
                                                    d
                                                  ) < 100 && (
                                                    <div className="progress">
                                                      <div
                                                        className="progress-bar "
                                                        style={{
                                                          width: `${getProgressVideoPercentage(
                                                            d
                                                          )}%`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                                {parseInt(version.actual) <
                                                  4 &&
                                                  getVideoProgressPercentage(
                                                    d.video
                                                  ) >= 100 && (
                                                    <div className="progress">
                                                      <div
                                                        className="progress-bar completed"
                                                        style={{
                                                          width: `${getVideoProgressPercentage(
                                                            d.video
                                                          )}%`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                                {parseInt(version.actual) >
                                                  4 &&
                                                  getProgressVideoPercentage(
                                                    d
                                                  ) >= 100 && (
                                                    <div className="progress">
                                                      <div
                                                        className="progress-bar completed "
                                                        style={{
                                                          width: `${getProgressVideoPercentage(
                                                            d
                                                          )}%`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                              </figcaption>
                                              <span className="content_ttl">
                                                {d?.video?.title}
                                              </span>
                                            </figure>
                                            <div className="recommend_list_content">
                                              <h6 onClick={handleShow}>
                                                {d.video.title
                                                  ? d.video.title
                                                  : ""}{" "}
                                              </h6>
                                              <p onClick={handleShow}>
                                                {d.video.author
                                                  ? d.video.author.name
                                                  : ""}{" "}
                                                <span></span>{" "}
                                                {query1.data.layer
                                                  ? query1.data.layer.title
                                                  : ""}
                                              </p>
                                              <div
                                                className="rate_timer"
                                                onClick={handleShow}
                                              >
                                                <span>
                                                  <img
                                                    src={Icons.Star}
                                                    alt="Star"
                                                    className="img-fluid"
                                                  />{" "}
                                                  {d?.video?.rating?.length >
                                                    1
                                                    ? d?.video?.rating
                                                    : d?.video?.rating + ".0"}
                                                </span>
                                                {parseInt(version.actual) <
                                                  4 && (
                                                    <span>
                                                      <img
                                                        src={Icons.Clock}
                                                        alt="Clock"
                                                        className="img-fluid"
                                                      />{" "}
                                                      {`${getTime(d.video)}`}
                                                    </span>
                                                  )}
                                                {parseInt(version.actual) >
                                                  4 && (
                                                    <span>
                                                      <img
                                                        src={Icons.Clock}
                                                        alt="Clock"
                                                        className="img-fluid"
                                                      />{" "}
                                                      {`${getVideoTime(
                                                        d.video
                                                      )}`}
                                                    </span>
                                                  )}
                                                {/* {
																						d.video.isNewVideo !== false &&
																						<span className="new_tag">New</span>
																					} */}
                                                <span className="play_icn">
                                                  <img
                                                    src={Icons.Play}
                                                    alt="Play"
                                                    className="img-fluid"
                                                  />
                                                </span>
                                              </div>
                                              {/* <span className="bookmark_icn" onClick={() => getBookmark({ variables: { contentType: "Videos", "topicId": d.video.topic, "subjectId": d.video.subject, "contentId": d.video._id, "isCompleted": d.video.progress.isCompleted, "courseName": course.preparingFor, "isBookMarked": !d.video.progress.isBookMarked, "status": "Pause" } })}>
																					{
																						d.video && d.video.progress && d.video.progress.isBookMarked ? (

																							<img src={Icons.unBookmark} alt="Play" className="img-fluid" />
																						) : (

																							<img src={Icons.Bookmark} alt="Play" className="img-fluid" />
																						)
																					}
																				</span> */}
                                            </div>
                                          </div>
                                        </li>
                                      ))
                                    : ""
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      {query1.data.layer &&
        query1.data.layer.subLayers.length === 0 &&
        ((query1.data.layer && query1.data.layer.subContents == null) ||
          (query1.data.layer.subContents &&
            query1.data.layer.subContents.length == 0)) && (
          <div className="main_wrapper">
            <div className="col-lg-12">
              <NoDataFound></NoDataFound>
            </div>
          </div>
        )}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="video_modal"
        centered
        size="lg"
      >
        {/* <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content"> */}
        {/* <div className="modal-body"> */}
        <Modal.Body>
          <div className="play_back_video">
            {/* <img src={Icons.ModalWarning} alt="warning" className="img-fluid" /> */}
            <img
              src={Images.VideopopupImg}
              alt="warning"
              className="img-fluid"
            />
            {/* <p>Video Play back available only on Mobile App</p> */}
            <span
              className="modal_cross"
              data-dismiss="modal"
              onClick={handleClose}
            >
              <img src={Icons.ModalCross} alt="cross" className="img-fluid" />
            </span>
          </div>
        </Modal.Body>
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
      </Modal>

      {/* // content layer */}
    </>
  );
}

export default OtherResource;
